
// Buddhabelief Mobile JS v1.1
// 修复 AVADA lazy-loading 在 iOS Safari 上失效的问题

(function() {
  'use strict';

  // ---- 修复 AVADA lazy-loading on iOS ----
  // AVADA 用 data-srcset 代替 srcset, 依赖 JS 触发
  // iOS Safari 有时不触发 IntersectionObserver, 导致图片显示为 ?
  function fixLazyImages() {
    var imgs = document.querySelectorAll('img.image-lazy-loading[data-srcset], img[data-src]');
    if (!imgs.length) return;

    // 如果 IntersectionObserver 可用就用,否则直接赋值
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries, obs) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            loadImg(entry.target);
            obs.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px 0px' });

      imgs.forEach(function(img) {
        // 已经加载过的跳过
        if (img.srcset || img.complete) return;
        observer.observe(img);
      });
    } else {
      // 降级: 直接全部赋值
      imgs.forEach(loadImg);
    }
  }

  function loadImg(img) {
    if (img.dataset.srcset) {
      img.srcset = img.dataset.srcset;
      img.removeAttribute('data-srcset');
    }
    if (img.dataset.src) {
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    }
    // sizes 属性
    if (img.dataset.sizes) {
      img.sizes = img.dataset.sizes;
    }
    img.classList.remove('image-lazy-loading');
  }

  // ---- Footer Accordion ----
  function initFooterAccordion() {
    var toggles = document.querySelectorAll('.bb-footer-toggle');
    toggles.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var content = btn.nextElementSibling;
        if (!content) return;
        var isOpen = content.classList.contains('open');
        // 关闭所有
        document.querySelectorAll('.bb-footer-content.open').forEach(function(el) {
          el.classList.remove('open');
        });
        document.querySelectorAll('.bb-footer-toggle').forEach(function(b) {
          b.setAttribute('aria-expanded', 'false');
          var arrow = b.querySelector('.bb-toggle-arrow');
          if (arrow) arrow.textContent = '+';
        });
        // 如果不是已开着的,打开它
        if (!isOpen) {
          content.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
          var arrow = btn.querySelector('.bb-toggle-arrow');
          if (arrow) arrow.textContent = '-';
        }
      });
    });
  }

  // ---- Sticky Buy Bar PDP ----
  function initStickyBar() {
    var bar = document.querySelector('.bb-sticky-bar');
    if (!bar) return;
    var addBtn = bar.querySelector('button[name="add"], .bb-add-to-cart');
    if (!addBtn) return;
    addBtn.addEventListener('click', function() {
      // 触发原生 add-to-cart
      var form = document.querySelector('form[action*="/cart/add"]');
      if (form) {
        var submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.click();
      }
    });
  }

  // ---- Cart Progress Bar ----
  function initCartProgress() {
    var fill = document.querySelector('.bb-progress-fill');
    if (!fill) return;
    // 计算 cart total 和 free shipping threshold
    var threshold = 100; // $100 free shipping
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var total = cart.total_price / 100;
        var pct = Math.min((total / threshold) * 100, 100);
        fill.style.width = pct + '%';
        var msg = document.querySelector('.bb-progress-msg');
        if (msg) {
          var remaining = Math.max(threshold - total, 0);
          if (remaining > 0) {
            msg.textContent = 'Add $' + remaining.toFixed(0) + ' more for free shipping';
          } else {
            msg.textContent = 'You qualify for FREE shipping!';
          }
        }
      })
      .catch(function() {});
  }

  // ---- View All button hover effect ----
  function initViewAllBtn() {
    var btn = document.querySelector('.bb-view-all-btn');
    if (!btn) return;
    btn.addEventListener('mouseenter', function() {
      btn.style.background = '#C8973A';
      btn.style.color = '#fff';
    });
    btn.addEventListener('mouseleave', function() {
      btn.style.background = 'transparent';
      btn.style.color = '#C8973A';
    });
  }

  // ---- Init ----
  function init() {
    fixLazyImages();
    initFooterAccordion();
    initStickyBar();
    initCartProgress();
    initViewAllBtn();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // 页面滚动时再次检查(应对 AVADA 懒加载时机问题)
  window.addEventListener('scroll', function() {
    fixLazyImages();
  }, { passive: true, once: true });

})();

// ===== BB Mobile Top Nav v3.0 (appended to bb-mobile.js, bypasses page cache) =====
(function(){
  function bbMnInit(){
    // Only mobile
    if(!window.matchMedia('(max-width:480px)').matches) return;
    // Remove old nav bars if present
    ['bb-topnav-bar','bb-topnav-drawer','bb-mob-nav-bar','bb-mob-nav-drawer','bb-mob-nav-style'].forEach(function(id){
      var el = document.getElementById(id);
      if(el) el.remove();
    });
    // Skip if already created
    if(document.getElementById('bb-topnav3')) return;

    // Inject CSS
    var css = document.createElement('style');
    css.id = 'bb-topnav3-css';
    css.textContent = [
      '#bb-topnav3{display:flex!important;position:fixed!important;top:0!important;left:0!important;right:0!important;width:100%!important;height:52px!important;background:#0a0806!important;border-bottom:1px solid rgba(201,168,76,0.25)!important;align-items:center!important;justify-content:space-between!important;padding:0 16px!important;z-index:2147483647!important;box-sizing:border-box!important}',
      '#bb-topnav3-logo{font-family:"Cinzel",Georgia,serif!important;font-size:12px!important;letter-spacing:.2em!important;color:#C9A84C!important;text-decoration:none!important;text-transform:uppercase!important;font-weight:400!important}',
      '#bb-topnav3-btn{display:flex!important;flex-direction:column!important;gap:5px!important;align-items:center!important;justify-content:center!important;width:44px!important;height:44px!important;background:none!important;border:none!important;cursor:pointer!important;padding:6px!important}',
      '#bb-topnav3-btn span{display:block!important;width:22px!important;height:2px!important;background:#C9A84C!important;border-radius:2px!important;transition:transform .3s,opacity .3s!important}',
      '#bb-topnav3-drawer{display:none!important;position:fixed!important;top:52px!important;left:0!important;right:0!important;bottom:0!important;background:#0a0806!important;z-index:2147483646!important;overflow-y:auto!important;padding-bottom:80px!important}',
      '#bb-topnav3-drawer.tn3open{display:block!important}',
      '.tn3-sec{border-bottom:1px solid rgba(201,168,76,0.08)!important}',
      '.tn3-head{display:flex!important;justify-content:space-between!important;align-items:center!important;padding:15px 20px!important;font-family:"Cinzel",Georgia,serif!important;font-size:11px!important;letter-spacing:.18em!important;color:#9E8E6A!important;text-transform:uppercase!important;cursor:pointer!important}',
      '.tn3-head.open{color:#C9A84C!important}',
      '.tn3-chev{transition:transform .3s!important;font-size:10px!important}',
      '.tn3-head.open .tn3-chev{transform:rotate(90deg)!important}',
      '.tn3-sub{display:none!important;padding:4px 0 12px!important;background:rgba(0,0,0,.3)!important}',
      '.tn3-sub.open{display:block!important}',
      '.tn3-sub a{display:block!important;padding:10px 28px!important;font-family:"Cormorant Garamond",Georgia,serif!important;font-size:15px!important;color:#BFB49A!important;text-decoration:none!important}',
      '.tn3-link{display:block!important;padding:15px 20px!important;font-family:"Cinzel",Georgia,serif!important;font-size:11px!important;letter-spacing:.18em!important;color:#9E8E6A!important;text-transform:uppercase!important;text-decoration:none!important;border-bottom:1px solid rgba(201,168,76,0.08)!important}',
      '.tn3-link-gold{color:#C9A84C!important}'
    ].join('');
    document.head.appendChild(css);

    // Create top bar
    var bar = document.createElement('div');
    bar.id = 'bb-topnav3';
    bar.innerHTML = '<a id="bb-topnav3-logo" href="/">Buddhabelief</a>'
      + '<button id="bb-topnav3-btn" onclick="tn3Toggle()" aria-label="Menu">'
      + '<span></span><span></span><span></span>'
      + '</button>';

    // Create drawer
    var drawer = document.createElement('div');
    drawer.id = 'bb-topnav3-drawer';
    drawer.innerHTML = [
      '<div class="tn3-sec"><div class="tn3-head" onclick="tn3Sub(this)">Tibetan Beads <span class="tn3-chev">&#9656;</span></div><div class="tn3-sub"><a href="/collections/double-loop-necklace-bracelet">Double-Loop Rosary</a><a href="/collections/single-turn-handheld">Handheld Rosary</a><a href="/collections/tibetan-bracelets">Tibetan Bracelets</a><a href="/collections/rosary-maintenance/Nianzhu">Rosary Care</a></div></div>',
      '<div class="tn3-sec"><div class="tn3-head" onclick="tn3Sub(this)">Haute Couture <span class="tn3-chev">&#9656;</span></div><div class="tn3-sub"><a href="/collections/haute-couture-rosary">Luxury Rosary</a><a href="/collections/custom-luxury-bracelets">Luxury Bracelets</a></div></div>',
      '<div class="tn3-sec"><div class="tn3-head" onclick="tn3Sub(this)">Thangka <span class="tn3-chev">&#9656;</span></div><div class="tn3-sub"><a href="/collections/thangka-pendant">Thangka Pendants</a><a href="/collections/thangka-home-decor">Home Decor</a><a href="/collections/thangka-matching-rope">Accessories</a></div></div>',
      '<div class="tn3-sec"><div class="tn3-head" onclick="tn3Sub(this)">More <span class="tn3-chev">&#9656;</span></div><div class="tn3-sub"><a href="/pages/exclusive-accessories">Zodiac Ornaments</a><a href="/collections/taoist-jewelry">Taoist Series</a><a href="/collections/fashion-accessories">Fashion</a></div></div>',
      '<a href="/blogs/news" class="tn3-link">Culture</a>',
      '<a href="/pages/about-us" class="tn3-link">About</a>',
      '<a href="/pages/contact" class="tn3-link">Contact</a>',
      '<a href="/collections/special-offers-section" class="tn3-link tn3-link-gold">Special Offers</a>'
    ].join('');

    // Insert at top of body
    document.body.insertBefore(drawer, document.body.firstChild);
    document.body.insertBefore(bar, document.body.firstChild);

    // Set body padding
    document.body.style.setProperty('padding-top', '52px', 'important');

    // Toggle functions
    window.tn3Toggle = function(){
      document.getElementById('bb-topnav3-drawer').classList.toggle('tn3open');
    };
    window.tn3Sub = function(el){
      var isOpen = el.classList.contains('open');
      document.querySelectorAll('.tn3-head.open').forEach(function(h){ h.classList.remove('open'); });
      document.querySelectorAll('.tn3-sub.open').forEach(function(s){ s.classList.remove('open'); });
      if(!isOpen){
        el.classList.add('open');
        el.nextElementSibling.classList.add('open');
      }
    };

    // Close drawer on outside click
    document.addEventListener('click', function(e){
      var b = document.getElementById('bb-topnav3');
      var d = document.getElementById('bb-topnav3-drawer');
      if(d && d.classList.contains('tn3open') && !b.contains(e.target) && !d.contains(e.target)){
        d.classList.remove('tn3open');
      }
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', bbMnInit);
  } else {
    bbMnInit();
  }
})();
